import { render, staticRenderFns } from "./WritePage.vue?vue&type=template&id=54d81986&scoped=true&"
import script from "./WritePage.vue?vue&type=script&lang=js&"
export * from "./WritePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d81986",
  null
  
)

export default component.exports